import { AddCircleOutline, RemoveCircleOutline } from '@mui/icons-material';
import { Box, Button, IconButton, TextField } from '@mui/material';
import { messages } from 'i18n/localization';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { MappingInfoData } from 'types/MappingInfoData';
import { TemplateEditSectionHeading } from '../../TemplateEditSectionHeading';
import mappingInfoDataJson from './mapping-info-data.json';
import { ISubmodelElement, Qualifier, Submodel } from 'api/v3/aas_core_meta/types';

interface MappingInfoEditComponentProps {
    data: Submodel | ISubmodelElement;
    onChange: (data: Submodel | ISubmodelElement) => void;
}

export function MappingInfoEditComponent(props: MappingInfoEditComponentProps) {
    const mappingInfoData = mappingInfoDataJson as unknown as MappingInfoData;
    const [data, setData] = useState(props.data);
    const [mappingInfo, setMappingInfo] = useState(getMappingInfo());
    const [valueEnabled, setValueEnabled] = useState(!!mappingInfo?.value?.length);

    useEffect(() => {
        setData(props.data);
        setMappingInfo(getMappingInfo());
    }, [props.data]);

    function getMappingInfo(): Qualifier | undefined {
        return data?.qualifiers?.find((q: Qualifier) => mappingInfoData.qualifierTypes.includes(q.type));
    }

    const onValueChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (mappingInfo) {
            setMappingInfo({ ...mappingInfo, value: event.target.value } as Qualifier);
            handleChange({ ...mappingInfo, value: event.target.value } as Qualifier);
        }
    };

    const onRemove = () => {
        setValueEnabled(false);
        setMappingInfo(undefined);
        handleChange(undefined);
    };

    const onAdd = () => {
        setValueEnabled(true);
        if (!mappingInfo) {
            setMappingInfo(mappingInfoData.emptyTemplate);
        }
        handleChange(mappingInfoData.emptyTemplate);
    };

    const handleChange = (newMappingInfo: Qualifier | undefined) => {
        const qualifiersIndex = data?.qualifiers?.findIndex((q: Qualifier) =>
            mappingInfoData.qualifierTypes.includes(q.type),
        );

        // update/remove if existing
        if (data.qualifiers && qualifiersIndex !== undefined && qualifiersIndex > -1) {
            if (newMappingInfo) {
                data.qualifiers[qualifiersIndex] = newMappingInfo;
            } else {
                data.qualifiers.splice(qualifiersIndex, 1);
            }
            // add as new
        } else if (newMappingInfo) {
            data.qualifiers = data.qualifiers ? [...data.qualifiers, newMappingInfo] : [newMappingInfo];
        }
        props.onChange(data);
    };

    return (
        <>
            <TemplateEditSectionHeading type="mappingInfo" />
            {valueEnabled && mappingInfo ? (
                <Box display="flex" alignContent="center">
                    <TextField
                        defaultValue={mappingInfo.value}
                        label={<FormattedMessage {...messages.mnestix.value} />}
                        onChange={onValueChange}
                        fullWidth
                    />
                    <IconButton color="primary" onClick={() => onRemove()} sx={{ alignSelf: 'center', ml: 1 }}>
                        <RemoveCircleOutline />
                    </IconButton>
                </Box>
            ) : (
                <Button size="large" startIcon={<AddCircleOutline />} onClick={() => onAdd()}>
                    <FormattedMessage {...messages.mnestix.add} />
                </Button>
            )}
        </>
    );
}
